import { createContext } from "react";
import { ChatsByCountriesDataEntry } from "../components/ChatsByCountriesWidget";
import { ImpactDistributionDataEntry } from "../components/ImpactDistributionWidget";
import { SentimentAnalysisDataEntry } from "../components/SentimentAnalysisWidget";
import { TopicDistributionDataEntry } from "../components/TopicDistributionWidget";
import { ImpactOverviewWidgetDataEntry } from "../components/ImpactOverviewWidget";

export interface AgentAnalyticsContextValue {
  chatsByCountriesData: ChatsByCountriesDataEntry[];
  impactOverviewWidgetData: ImpactOverviewWidgetDataEntry[];
  impactDistributionData: ImpactDistributionDataEntry[];
  impactDetailsById: Record<string, ImpactDistributionDataEntry>;
  topicDistributionData: TopicDistributionDataEntry[];
  sentimentAnalysisData: SentimentAnalysisDataEntry[];
  timeRange: { fromISO: string; toISO: string };
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export const AgentAnalyticsContext =
  createContext<AgentAnalyticsContextValue | null>(null);
